import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";
import {
    NotificacionToastDeCreacion,
    NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";
import * as TipoDeError from "../../isp._comun/services/Errores";

import ContratoReducer from "../reductores/ContratoReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";

import CargaDeContratoConsultado from "../reductores/acciones/dispatch/CargaDeContratoConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

// import { TipoDeItem } from "../../reductores/Constantes";
import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import ServiceRegistroDeContrato from "../../isp.žapi.contratos/ServiceRegistroDeContrato";
import ServiceActualizacionContrato from "../../isp.žapi.contratos/ServiceActualizacionContrato";
import ServiceQueryUnContrato from "../../isp.žapi.contratos/ServiceQueryUnContrato";

import DialogoContratoLayout from "./layouts/DialogoContratoLayout";
import DataDeRespuestas_Servicio from "./DataEstaticaDeRespuestas.json";

const DialogoContrato = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        handleErroresExtraEnPrincipal,
        notificar,
    } = useContext(GlobalContext);

    const [estadoDCF, dispatchDCF] = useReducer(ContratoReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;

    const ServiceApiRegistrarContrato = new ServiceRegistroDeContrato();
    const registrarContratoCommand = new ComandoAPI(ServiceApiRegistrarContrato);

    registrarContratoCommand.ejecutar = async () => {
        const Contrato = {
            tipoItem: estadoDCF.domain.screen.tipoItem,
            nombre: estadoDCF.domain.screen.nombre,
            descripcion: estadoDCF.domain.screen.descripcion,
            precio: estadoDCF.domain.screen.precio,
            moneda: estadoDCF.domain.screen.moneda,
            udm: estadoDCF.domain.screen.udm,
        };

        try {
            // const Servicio = new ServicioRegistroDeItem();
            // const Servicio = new ServicioRegistroDeItem();
            // registrarItemCommand.Servicio = Servicio;
            // registrarItemCommand.Servicio = Servicio;

            // const dataRegistradaDeItem = await Servicio.ejecutar(item);
            // const dataRegistradaDeItem = await Servicio.ejecutar(item);
            const dataRegistradaDeItem = await ServiceApiRegistrarContrato.ejecutar(Contrato);
            // const dataRegistradaDeItem = await registrarItemCommand.Servicio.ejecutar(item);
            // const dataRegistradaDeItem = await registrarItemCommand.Servicio.ejecutar(item);
            // await new ServicioRegistroDeClienteAFacturar().ejecutar(item);
            // await new ServicioRegistroDeClienteAFacturar().ejecutar(item);
            dispatchDCF(new Action.CargaDeContratoRegistrado(dataRegistradaDeItem));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_Servicio.CreacionServicio.titulo,
                    DataDeRespuestas_Servicio.CreacionServicio.mensaje,
                    dataRegistradaDeItem.idItem
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearContrato(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            // throw error;
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const ServicioApiActualizarContrato = new ServiceActualizacionContrato();
    const actualizarContratoCommand = new ComandoAPI(ServicioApiActualizarContrato);
    actualizarContratoCommand.ejecutar = async () => {
        // actualizarServicioCommand.ejecutar = useHandlerDeComandoConSesionActiva(async () => {
        // actualizarServicioCommand.ejecutar = useHandlerDeComandoConSesionActiva(async () => {
        const itemPorActualizar = {
            id: estadoDCF.domain.screen.idItem,
            data: estadoDCF.domain.update,
        };

        try {
            // const Servicio = new ServicioDeActualizacionDeItem();
            // const Servicio = new ServicioDeActualizacionDeItem();
            // actualizarItemCommand.Servicio = Servicio;
            // actualizarItemCommand.Servicio = Servicio;
            // const dataDeClienteActualizado =
            await ServicioApiActualizarContrato.ejecutar(itemPorActualizar);
            dispatchDCF(
                new Action.CargaDeContratoActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarContrato(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                    /* new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError +
                            CodigoDeError[nombreDeError] +
                            "\n" +
                            DataDeRespuestas_Comun[nombreDeError].descripcion
                    ) */
                /*); */
            }
            handleErroresExtraEnPrincipal(error);
            // throw error;
        }
    };

    const ServicioApiQueryUnContrato = new ServiceQueryUnContrato();
    const buscarUnSoloContratoCommand = new ComandoAPI(ServicioApiQueryUnContrato);

    buscarUnSoloContratoCommand.ejecutar = async (idItem) => {
        try {
            // const Servicio = new ServicioDeQueryDeUnItem();
            // const Servicio = new ServicioDeQueryDeUnItem();
            // buscarUnSoloItemCommand.Servicio = Servicio;
            // buscarUnSoloItemCommand.Servicio = Servicio;
            const respuestaQuery = await ServicioApiQueryUnContrato.ejecutar(idItem);
            dispatchDCF(new CargaDeContratoConsultado(respuestaQuery.item));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            throw error;
        }
    };

    return (
        <DialogoContratoLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            registrarContratoCommand={registrarContratoCommand}
            actualizarContratoCommand={actualizarContratoCommand}
            buscarUnSoloContratoCommand={buscarUnSoloContratoCommand}
        />
    );
};

export default DialogoContrato;
